import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/hyq",
    // component: () => import(/* webpackChunkName: "login" */ "../views/qxb.vue"),
    // meta: { title: "海南亿万未来科技有限公司" },
  },
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "home" */ "../components/box.vue"),
    meta: { title: "自述文件" },
    children: [
      {
        path: "/home",
        component: () =>
          import(/* webpackChunkName: "dashboard" */ "../views/home.vue"),
        meta: { title: "首页" },
      },

      {
        path: "/qxb",
        component: () =>
          import(/* webpackChunkName: "dashboard" */ "../views/qxb.vue"),
        meta: { title: "钱小宝" },
      },
      {
        path: "/wyh",
        component: () =>
          import(/* webpackChunkName: "dashboard" */ "../views/wyh.vue"),
        meta: { title: "无忧花" },
      },
      {
        path: "/hyq",
        component: () =>
          import(/* webpackChunkName: "dashboard" */ "../views/hyq.vue"),
        meta: { title: "惠有钱" },
      },
      {
        path: "/xjk",
        component: () =>
          import(/* webpackChunkName: "dashboard" */ "../views/xjk.vue"),
        meta: { title: "小金库" },
      },
      {
        path: "/myqb",
        component: () =>
          import(/* webpackChunkName: "dashboard" */ "../views/myqb.vue"),
        meta: { title: "蜜柚钱包" },
      },
      {
        path: "/xxj",
        component: () =>
          import(/* webpackChunkName: "dashboard" */ "../views/xiaohuaxin.vue"),
        meta: { title: "小薪迹" },
      },
      {
        path: "/hyq-yinsi",
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ "../views/xieyi/hyq/yinsi.vue"
          ),
        meta: { title: "隐私政策" },
      },
      {
        path: "/qxb-yinsi",
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ "../views/xieyi/qxb/yinsi.vue"
          ),
        meta: { title: "隐私政策" },
      },
      {
        path: "/xjk-yinsi",
        component: () =>
            import(
                /* webpackChunkName: "dashboard" */ "../views/xieyi/xjk/yinsi.vue"
                ),
        meta: { title: "隐私政策" },
      },
      {
        path: "/xxj-yinsi",
        component: () =>
            import(
                /* webpackChunkName: "dashboard" */ "../views/xieyi/xhx/yinsi.vue"
                ),
        meta: { title: "隐私政策" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
